import PropTypes from "prop-types";

import AssignmentsCompleteIcon from "@/icons/AssignmentsCompleteIcon";
import {
  iconCss,
  questionCss,
  rootCss,
  warningCss,
} from "./WritePromptConfirmationScreen.style";

const propTypes = {
  writePromptConfirmationScreenRef: PropTypes.object,
};

const WritePromptConfirmationScreen = ({
  writePromptConfirmationScreenRef,
}) => {
  return (
    <div css={rootCss}>
      <div>
        <AssignmentsCompleteIcon css={iconCss} />
        <p
          tabIndex={0}
          ref={writePromptConfirmationScreenRef}
          css={questionCss}
        >
          Did you double-check your work?
        </p>
        <p css={warningCss}>
          You won't be able to edit your response after you submit it.
        </p>
      </div>
    </div>
  );
};

WritePromptConfirmationScreen.propTypes = propTypes;

export default WritePromptConfirmationScreen;
